export default function CtaBand() {
  return (
    <section className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-r from-secondary-500 via-primary-500 to-accent-500 px-6 py-10 text-center md:px-12 md:py-14">
          <div className="pointer-events-none absolute inset-0 dot-grid-light opacity-50" />
          <div className="relative">
            <p className="font-heading text-2xl leading-snug text-background-50 md:text-4xl">
              想第一时间追到最新鲜的料？
            </p>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-background-50/90 md:text-base">
              从实时速报到全网热榜，滚动更新的即时内容等你随时刷新。现在就从第一条速报开始你的追更。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#feed"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition hover:-translate-y-0.5"
              >
                回到实时速报
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="mailto:hello@kanliaozhan.example"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/50 transition hover:bg-background-50/10"
              >
                <i className="ri-mail-send-line" />
                投稿线索
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}